import React from 'react';
import { useDispatch } from 'react-redux';

import { ResponsiveDialog, useFilters, useSettings, useUserData, Utils } from 'app/main/components';
import ImportFromRowsPreviewDialog from '../../components/ImportFromRowsPreviewDialog';
import CommercialCampaignsRowsImportFiltersDialog from './CommercialCampaignsRowsImportFiltersDialog';

interface CommercialCampaignsRowsImportDialogProps {
	openDialog: boolean;
	switchOpenDialog: VoidFunction;
	cmcpUid: string;
	table: string;
	updateRefresh: VoidFunction;
}

export default function CommercialCampaignsRowsImportDialog(props: CommercialCampaignsRowsImportDialogProps) {
	const dispatch = useDispatch();
	const userData = useUserData();

	const [srcModule, setSrcModule] = React.useState('marketingactions');
	const { settings, t } = useSettings(srcModule);
	const { settings: tableSettings } = useSettings(props.table);

	const [srcUid, setSrcUid] = React.useState<string | undefined>();
	const [showFilteredResults, setShowFilteredResults] = React.useState(false);

	const srcModuleRows = srcModule === 'dems' ? `${srcModule}_recipients` : `${srcModule}_rows`;
	const srcModuleShortRows = srcModule === 'commercialcampaigns' ? 'cmrw' : srcModule === 'dems' ? 'mail' : 'marw';

	const filterProps = useFilters({
		module: srcModuleRows,
		defaultFilters: [
			{ filt_field: `${tableSettings.modu_short}_deleted`, filt_clause: 'not_equal', filt_value: 1 },
			{ filt_field: `${settings.modu_short}_uid`, filt_clause: 'equals', filt_value: srcUid },
			{ filt_field: `${srcModuleShortRows}_table`, filt_clause: 'equals', filt_value: props.table }
		]
	});

	const showResults = () => {
		filterProps.handleFiltersApply();
		setShowFilteredResults(true);
	};

	const closeDialog = () => {
		filterProps.handleFiltersClear();
		props.switchOpenDialog();
		setShowFilteredResults(false);
	};

	const addRecipient = () => {
		Utils.executeStored({
			action: 'st_commercialcampaigns_rows_add_multiple',
			dispatch,
			data: {
				cmrw_cmcp_uid: props.cmcpUid,
				cmrw_user_created_uid: userData.user_uid,
				cmrw_table: props.table,
				src_module: srcModule,
				src_module_uid: srcUid,
				filters: filterProps.filters
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				setSrcUid(undefined);
				closeDialog();
				props.updateRefresh();
			}
		});
	};

	if (!showFilteredResults)
		return (
			<ResponsiveDialog open={props.openDialog} onClose={props.switchOpenDialog} maxWidth="lg" scroll="body">
				<CommercialCampaignsRowsImportFiltersDialog
					uid={props.cmcpUid}
					table={props.table}
					srcModule={srcModule}
					setSrcModule={setSrcModule}
					srcUid={srcUid}
					setSrcUid={setSrcUid}
					currentFilters={filterProps.currentFilters}
					defaultFilters={filterProps.defaultFilters}
					handleFilterChange={filterProps.handleFilterChange}
					setCurrentFilters={filterProps.setCurrentFilters}
					showResults={showResults}
					closeDialog={closeDialog}
				/>
			</ResponsiveDialog>
		);
	else
		return (
			<ResponsiveDialog open={props.openDialog} onClose={props.switchOpenDialog} maxWidth="lg">
				<ImportFromRowsPreviewDialog
					title={t('COMMERCIALCAMPAIGNS_DIALOG_TITLE_ADD_RESULT')}
					module={srcModuleRows}
					defaultFilters={filterProps.filters}
					addRows={addRecipient}
					goBack={() => setShowFilteredResults(false)}
				/>
			</ResponsiveDialog>
		);
}
